var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollabsCropped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 47.31 41.2"
    },
    xmlSpace: "preserve",
    viewBox: "11.79 11.53 20.73 20.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8626",
    d: "M22.15,11.53c-5.72,0-10.36,4.64-10.36,10.37s4.64,10.36,10.37,10.36  s10.36-4.65,10.36-10.37c0-2.75-1.09-5.38-3.04-7.33C27.54,12.62,24.9,11.53,22.15,11.53z M27.77,18.08  c0.37-0.01,0.71,0.61,0.46,0.86l-4.58,4.58c-0.24,0.24-0.55,0.41-0.89,0.47l-6.17,1.7c-0.39,0.11-0.8-0.58-0.53-0.85l4.58-4.58  c0.24-0.24,0.55-0.41,0.89-0.47l6.17-1.7C27.73,18.08,27.75,18.08,27.77,18.08L27.77,18.08z M22.15,20.65  c-0.69,0-1.24,0.56-1.24,1.24c0,0.69,0.56,1.24,1.24,1.24c0.69,0,1.24-0.56,1.24-1.24c0-0.33-0.13-0.65-0.36-0.88  C22.8,20.78,22.48,20.65,22.15,20.65z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabsCropped);
export default __webpack_public_path__ + "static/media/collabs-cropped.cbfac587a567ed366e12c73946a08561.svg";
export { ForwardRef as ReactComponent };